module.exports = __webpack_public_path__ + "img/qdefa.670aa3e2.png";